import * as a11y from '../vendor/theme-scripts/theme-a11y';
import debounce from '../util/debounce';

const selectors = {
  apiSearchResults: '[data-api-search-results]',
  searchInput: 'input[type="search"]',
  searchType: 'input[name="type"]',
  searchPopdown: '[data-search-popdown]',
  searchResults: '[data-search-results]',
  searchResultsOuter: '[data-search-results-outer]',
};

const classes = {
  searched: 'is-searched',
  loading: 'is-loading',
};

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector(selectors.searchInput);
    this.searchResults = this.querySelector(selectors.searchResults);
    this.searchResultsOuter = this.querySelector(selectors.searchResultsOuter);
    this.searchPopdown = this.querySelector(selectors.searchPopdown);
    this.searchType = this.querySelector(selectors.searchType).value;

    this.a11y = a11y;

    this.input.addEventListener(
      'input',
      debounce((event) => {
        const val = event.target.value;
        if (val && val.length > 1) {
          this.searchResultsOuter.classList.add(classes.loading);
          this.onChange(event);
        } else {
          this.reset();
        }
      }, 300).bind(this)
    );

    this.input.addEventListener('clear', this.reset.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${this.searchType}&${encodeURIComponent(
        'resources[limit]'
      )}=4&section_id=header-predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const cleanResponse = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup = cleanResponse.querySelector(selectors.apiSearchResults).innerHTML;

        this.searchResults.innerHTML = resultsMarkup;
        this.searchPopdown.classList.add(classes.searched);
        this.searchResultsOuter.classList.remove(classes.loading);
      })
      .catch((error) => {
        throw error;
      });
  }

  reset() {
    this.searchResults.innerHTML = '';

    this.searchPopdown.classList.remove(classes.searched);
    this.input.val = '';
    this.a11y.removeTrapFocus();
  }
}

export {PredictiveSearch};
